/// <amd-module name="Tfs/Frame/Components/Header/WithHeaderProgressBar" />
import * as React from "react";

import { ObservableValue } from "VSS/Core/Observable";
import { IVssContributionEventService } from "VSS/Platform/Contribution";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { IndeterminateProgressBar } from "VSSUI/ProgressBar";

interface IWithHeaderProgressBarState {
    loading: ObservableValue<boolean> | undefined;
}

export class WithHeaderProgressBar extends VssComponent<{}, IWithHeaderProgressBarState> {
    public constructor(props: {}, context: IVssComponentContext) {
        super(props, context);
        this.state = { loading: new ObservableValue(true) };
    }

    public render(): JSX.Element {
        return (
            <>
                {this.props.children}
                {this.state.loading !== undefined && (
                    <IndeterminateProgressBar
                        className="project-header-progress"
                        loading={this.state.loading}
                        loadingAnimationComplete={this.clearLoading}
                    />
                )}
            </>
        );
    }

    public componentDidMount() {
        super.componentDidMount();
        document.body.addEventListener("fpsLoading", this.startLoading);
        this.markCompletedAfterTTI();
    }

    public componentWillUnmount() {
        super.componentWillUnmount();
        const contributedEventService = this.context.pageContext.getService<IVssContributionEventService>("IVssContributionEventService");
        contributedEventService.unsubscribe(() => {
            this.setLoadingComplete();
        }, "page-rendered");
        document.body.removeEventListener("fpsLoading", this.startLoading);
    }

    private clearLoading = () => {
        this.setState({ loading: undefined });
    };

    private markCompletedAfterTTI() {
        const contributedEventService = this.context.pageContext.getService<IVssContributionEventService>("IVssContributionEventService");
        contributedEventService.subscribe(() => {
            this.setLoadingComplete();
        }, "page-rendered");
    }

    private startLoading = () => {
        this.setState({ loading: new ObservableValue(true) });
    };

    private setLoadingComplete = () => {
        if (this.state.loading) {
            this.state.loading.value = false;
        }
    };
}
